var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',{staticClass:"sale-receipt"},[_c('i',{staticClass:"graphic el-icon-success"}),_c('h2',[_vm._v("Reparcelamento realizado")])])}
var staticRenderFns = []

export { render, staticRenderFns }